document.addEventListener("turbo:before-cache", function() {
  $(".toast").remove()
  $('.dropdown .dropdown-menu.show').dropdown('hide')
})

document.addEventListener('turbo:load', () => {
  $('#featured-selections').on('click', 'a.list-group-item-action', function () {
    $(this).find('.text-muted.small').append('<span class="fa fa-spinner fa-pulse ml-2">')
  })
});

document.addEventListener('turbo:load', () => {
  $(document).on('click', '.modal-close-and-reload', function () {
    $('.modal').modal('dispose')
    window.location.reload();
  })
});


document.addEventListener("turbo:load", function(){
  $('.toggle-button').on('click', function () {
    $(this).toggleClass('active')
  });
});

document.addEventListener("turbo:load", function(){
  $(document).on('change', '#sales-group-by', function(event) {
    if (event.target.value == 'producer tag') {
      $(this).closest('.group-by-container').find('.collapse.producer-tags').collapse('show');
      $(this).closest('.group-by-container').find('.collapse.buyer-tags').collapse('hide');
    } else if (event.target.value == 'buyer tag') {
      $(this).closest('.group-by-container').find('.collapse.buyer-tags').collapse('show');
      $(this).closest('.group-by-container').find('.collapse.producer-tags').collapse('hide');
    } else {
      $(this).closest('.group-by-container').find('.collapse').collapse('hide');
    }
  })
});

document.addEventListener("turbo:load", function(){
  let shiftPressedTimes = 0;
  let shiftTimer = null;
  document.addEventListener('keydown', function(event) {
    // Check if Shift is pressed
    if (event.key === 'Shift') {
        shiftPressedTimes++;
        // Reset after 1 second if Shift wasn't pressed twice within the timeframe
        if (shiftTimer) {
            clearTimeout(shiftTimer);
        }
        shiftTimer = setTimeout(function() {
            shiftPressedTimes = 0;
        }, 1000);

        // If Shift is pressed twice
        if (shiftPressedTimes === 2) {
            // Listen for 'b' key
            document.addEventListener('keydown', function(event) {
                if (event.key.toLowerCase() === 'b') {
                    $('#buyers-dropdown .dropdown-toggle').dropdown('toggle');
                    $('#buyers-go').trigger("focus")
                    shiftPressedTimes = 0; // Reset Shift press counter
                    return event.preventDefault();
                }
                else if (event.key.toLowerCase() === 's') {
                    $('#sellers-dropdown .dropdown-toggle').dropdown('toggle');
                    $('#sellers-go').trigger("focus")
                    shiftPressedTimes = 0; // Reset Shift press counter
                    return event.preventDefault();
                }
                else if (event.key.toLowerCase() === 'o') {
                  $('#sales-order-dropdown .dropdown-toggle').dropdown('toggle');
                  $('#sales_order_go').trigger("focus")
                  shiftPressedTimes = 0; // Reset Shift press counter
                  return event.preventDefault();
                }
                else if (event.key.toLowerCase() === 'p') {
                  $('#purchase-order-dropdown .dropdown-toggle').dropdown('toggle');
                  $('#purchase_order_go').trigger("focus")
                  shiftPressedTimes = 0; // Reset Shift press counter
                  return event.preventDefault();
                }
                else if (event.key.toLowerCase() === 'f') {
                  $('#products-dropdown .dropdown-toggle').dropdown('toggle');
                  $('#forecasts-go').trigger("focus")
                  shiftPressedTimes = 0; // Reset Shift press counter
                  return event.preventDefault();
                }
          }, { once: true });
        }
    } else {
      shiftPressedTimes = 0;
    }
  });
})

document.addEventListener("turbo:load", function(){
  $('#products-dropdown').on('shown.bs.dropdown', function () {
    $(this).find('#products-go').trigger("focus")
  });
});

$(document).on('change', "select.submit-on-change, input.submit-on-change", function( event ) {
  Rails.fire(this.form, "submit")
});

$(document).on('change', "select.turbo-submit-on-change, input.turbo-submit-on-change", function( event ) {
  this.form.requestSubmit()
});

$(document).on('keyup', '.warehouse-location-code-field', function () {
  var input = $(this)
  var spinner = input.closest('.input-group').find('.warehouse-location-spinner')
  spinner.removeClass('d-none')
  clearTimeout(input.data('debounce-timer'))
  input.data('debounce-timer', setTimeout(function () {
    Rails.ajax({
      url: input.data('url') + '?code=' + encodeURIComponent(input.val()),
      dataType: 'script',
      type: 'get',
      complete: function () {
        spinner.addClass('d-none')
      }
    })
  }, 1000))
})

$(document).on('show.bs.popover', '.popover-product-unit', function () {
  var popover =  $(this)
  var product_unit_id = popover.data().id
  var as_of_date = popover.data().date
  Rails.ajax({
    url: "/admin/product_units/" + product_unit_id + "/buyer_order_items/?on=" + as_of_date ,
    dataType: "script",
    type: "get"
  })
})

document.addEventListener('turbo:load', () => {
  var options = {
    delay: { show: 300, hide: 50 },
    trigger: 'manual',
    html: true
  };
  var $popover = $('.popover-product-unit').popover(options);

  $popover.on('mouseenter', function () { // This is entering the triggering element
    var self = this;

    clearTimeout(self.timeout);
    self.hoverState = 'in';

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') {
        $(self).popover("show");

        $(".popover, .popover *").on('mouseover', function () { // This is moving over the popover
          clearTimeout(self.timeout);
        });

        $(".popover").on('mouseleave', function () { // This is leaving the popover
          self.timeout = setTimeout(function () {
            if (self.hoverState == 'out') {
              $(self).popover('hide');
            }
            }, options.delay.hide);
          });
        }
    }, options.delay.show);
  }).on('mouseleave', function (event) { // This is leaving the triggering element
      var self = this;

      clearTimeout(self.timeout);
      self.hoverState = 'out';

      self.timeout = setTimeout(function () {
        if (self.hoverState == 'out') {
          $(self).popover('hide');
        }
      }, options.delay.hide);
  });
})


$(document).on('click', '.popover-order-items tr', function () {
  var target =  $(this).data('target')
  window.open(target, '_blank')
})


$(document).on('show.bs.dropdown', '.alternatives-dropdown', function () {
  var dropdownMenu = $(this)
  var item_id = dropdownMenu.data().id
  Rails.ajax({
    url: "/admin/checkout_items/" + item_id + "/alternatives",
    dataType: "script",
    type: "get"
  })
})
$(document).on('hide.bs.dropdown', '.alternatives-dropdown', function () {
  var spinner = "<div class='dropdown-item disabled py-5'>Looking for alternatives <span class='fa fa-fw fa-spinner fa-pulse'></span></div>"
  $(this).find('.alternatives').html(spinner)
})


document.addEventListener('turbo:load', () => {
  $(".send-form-on-change").change(function(){
    var form = $(this).closest('form')[0];
    Rails.fire(form, "submit")
  });

  $("select[name='product_unit[packing_volume_id]']").change(function(){
    var form = $(this).closest('form')[0];
    Rails.fire(form, "submit")
  });

  $(".toggler").click(function () {
    var checkAll = $(this).text() == 'show details'
    if (checkAll) {
      $(this).text('hide details');
    } else {
      $(this).text('show details');
    }
  });



  $(document).on('change', "#route_run_vehicle_id", function(event) {
    if (event.target.value == "0") {
      window.open(event.target.dataset.url, '_blank');
    }
  })

  $('#order-receiving').on('click', '.additive-button', function(){
    var add = Number($(this).data('plus'))
    var quantityInput = $(this).closest('.receiving-item').find('.quantity');
    var currentQty = Number(quantityInput.val());

    quantityInput.val(Math.max(currentQty + add, 0))
  });

  $("#per_page").change(function(){
    $(this).closest('form').submit();
  });

  $('form').on('click', '.copy-blanks-estimates', function() {
    $('input[data-estimate]').each(
      function() {
        var current_value = $(this).val()
        if (current_value) { return }
        var estimate_value = $(this).data().estimate
        if (!current_value && estimate_value == 0) { return }
        $(this).val(estimate_value)
      }
    )
    return event.preventDefault();
  });

  var updatePaymentTotal = function() {
    var newTotal = 0
    $('tbody input.apply-payment-destination').each(
      function() { newTotal += Number($(this).val())}
    )
    newTotal = Number(newTotal.toFixed(2))
    var expectedTotal = Number($('#payment_value').data('value') || $('#payment_value').val())
    $('#calculated_payment_total').val(newTotal.toFixed(2))
    if (newTotal === expectedTotal) {
      $('#calculated_payment_total').addClass('is-valid')
      $('#calculated_payment_total').removeClass('is-invalid')
    } else {
      $('#calculated_payment_total').addClass('is-invalid')
      $('#calculated_payment_total').removeClass('is-valid')
    }
  }
  window.updatePaymentTotal = updatePaymentTotal

  var updateRemainingBalance = function() {
    var expectedTotal = Number($('#payment_value').val())
    var totalApplied = Number($('#calculated_payment_total').val())
    var newValue = expectedTotal ? (expectedTotal - totalApplied).toFixed(2) : 0
    $('#payment_new_credit').val(newValue)
  }

  $('form').on('click', '.apply-payment', function() {
    var sumApplied = 0
    $(this).closest('tr').find('input.apply-payment-destination').val('')
    $('tbody input.apply-payment-destination').each(
      function() { sumApplied += Number($(this).val())}
    )
    var remaining = Number($(this).data('remaining'))
    var expectedTotal = Number($('#payment_value').val())
    var totalRemaining = expectedTotal - sumApplied
    var toSet = totalRemaining < 0 ? totalRemaining : Math.min(totalRemaining, remaining)

    $(this).closest('tr').find('input.apply-payment-destination').val(toSet.toFixed(2))

    updatePaymentTotal();
    updateRemainingBalance();
    return event.preventDefault();
  });

  $('form tbody').on('change', 'input', function() {
    updatePaymentTotal();
    updateRemainingBalance();
  })

  if ( $('#payment-element').data('pk') ) {
    const pk = $('#payment-element').data('pk')
    const stripe = Stripe(pk);

    var cardButton = document.getElementById('card-button');
    var clientSecret = cardButton.dataset.secret;

    var elements = stripe.elements({ clientSecret: clientSecret });
    var paymentElement = elements.create('payment', {
      fields: { billingDetails: { name: 'always' } },
      wallets: { link: 'never' }
    });
    paymentElement.mount('#payment-element');

    cardButton.addEventListener('click', async function(ev) {
      ev.preventDefault();
      var radioButton = document.querySelector('input[name="payment_method"]:checked');

      $('#stripe-error-message').slideUp();
      $('#stripe-error-message .alert').text('')
      $(cardButton).text('Submitting...');
      $(cardButton).prop('disabled', true);

      var result;
      if (radioButton.value == 'new_card') {
        var submission = await elements.submit();
        if (submission.error) {
          $('#stripe-error-message .alert').text(submission.error.message)
          $('#stripe-error-message').slideDown();
          $(cardButton).text('Submit Payment');
          $(cardButton).prop('disabled', false);
          return;
        }

        result = await stripe.confirmPayment({
          elements: elements,
          confirmParams: {
            return_url: cardButton.dataset.returnUrl
          },
          redirect: 'if_required'
        });
      } else {
        result = await stripe.confirmCardPayment(clientSecret, {
          payment_method: radioButton.value
        });
      }

      if (result.error) {
        $('#stripe-error-message .alert').text(result.error.message)
        $('#stripe-error-message').slideDown();
        $(cardButton).text('Submit Payment');
        $(cardButton).prop('disabled', false);
      } else {
        Turbo.visit(cardButton.dataset.redirect);
      }
    });
  }
});
